module.exports = __webpack_public_path__ + "b6ecedbef1f9fd204ded35ab8bc02bd7.png";